import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/Bits";
import { AccountTab } from "@/components/settings/AccountTab";
import { NotificationsTab, RemindersTab } from "@/components/settings/NotifyTabs";
import { WallboardTab } from "@/components/settings/WallboardTab";
import { AiTab, TeamTab } from "@/components/settings/TeamAiTabs";
import { FunTab } from "@/components/settings/FunTab";

const TABS = [
  ["account", "My account", AccountTab], ["notifications", "Notifications", NotificationsTab],
  ["wallboard", "Wallboard", WallboardTab], ["reminders", "Reminders", RemindersTab],
  ["team", "Team", TeamTab], ["ai", "AI", AiTab], ["fun", "Fun stuff", FunTab],
];

export default function Settings() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "account";
  return (
    <div data-testid="settings-page">
      <PageHeader title="Settings" subtitle="The serious bits, and the silly bits. Changes save as you go." />
      <Tabs value={tab} onValueChange={(t) => setParams({ tab: t })}>
        <TabsList className="mb-6 flex h-auto w-full flex-wrap justify-start gap-1 bg-card/60 p-1">
          {TABS.map(([k, label]) => <TabsTrigger key={k} value={k} data-testid={`settings-tab-${k}`} className="rounded-full px-4">{label}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k} className="max-w-4xl"><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
